module.exports = __webpack_public_path__ + "img/0111.1dcd4a4a.png";